<template>
  <div class="container">
    <HeadingOne>現在ご利用いただけるサービス</HeadingOne>
    <p>
      以下のサービスは、退会のお手続き完了時にお送りしたメールに記載の期限までご利用いただけます。
    </p>
    <p>期限を過ぎた場合は、ご利用いただけなくなりますのでご注意ください。</p>
    <p>
      なお、お取引履歴（マンスリーステートメント）は、毎月11日頃に前月分を掲載いたします。
    </p>

    <section>
      <HeadingTwo>お取引履歴（マンスリーステートメント）のご確認</HeadingTwo>
      <ListGroup class="-link _mb-sm-30 _mb-md-60">
        <template v-if="Object.keys(reportMap).length > 0">
          <template v-for="(yearMonth, index) in yearMonthList">
            <ListItem
              v-if="reportMap[dateToyyyyMmStr(yearMonth)]"
              :key="'report' + index"
              href="#"
              class="-link"
              @click.prevent="showPdf(yearMonth)"
            >
              <ElementBox class="-center">
                <HeadingIcon class="_mb-0">
                  <p class="heading _mb-0">
                    {{ yyyyMmJpDateFormat(yearMonth) }}
                  </p>
                  <IconBox
                    src="pdf"
                    class="icon -sm _ml-sm-5 _ml-md-10"
                  ></IconBox>
                </HeadingIcon>
              </ElementBox>
            </ListItem>
          </template>
        </template>
      </ListGroup>

      <BtngroupSingle class="_mb-md-120 _mb-sm-60">
        <BtnMain class="-main" @click.prevent="logout"> ログアウト </BtnMain>
      </BtngroupSingle>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import {
  getPdfFileLambdaInvoke,
  getUserSessionLambdaInvoke,
  apiGetPdfFile,
} from "@/utils/LambdaHelper";
import {
  removeUserSessionCookie,
  initCredentials,
  authLogout,
} from "@/utils/Auth";
import { dateToyyyyMmStr } from "@/utils/DateHelper";
import HeadingOne from "@/components/heading/HeadingOne";
import HeadingTwo from "@/components/heading/HeadingTwo";
import ListGroup from "@/components/list/ListGroup";
import ListItem from "@/components/list/ListItem";
import ElementBox from "@/components/elements/ElementBox";
import HeadingIcon from "@/components/heading/HeadingIcon";
import IconBox from "@/components/icons/IconBox";
import BtngroupSingle from "@/components/button/BtngroupSingle";
import BtnMain from "@/components/button/BtnMain";
import { goToErrorPage } from "@/utils/Other";

export default {
  name: "Mb044",
  components: {
    BtnMain,
    BtngroupSingle,
    IconBox,
    HeadingIcon,
    ElementBox,
    ListItem,
    ListGroup,
    HeadingTwo,
    HeadingOne,
  },
  setup() {
    setMeta({
      title: "会員サイト",
      description:
        "au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,会員,会員サイト,ご契約内容",
    });
  },
  data() {
    return {
      yearMonthList: [],
      reportMap: {},
      userSessionData: {
        user_session: "",
        state: "",
      },
    };
  },
  mounted() {
    for (let i = 0; i < 3; i++) {
      let targetMonth = new Date(
        new Date().setMonth(new Date().getMonth() - i)
      );
      this.yearMonthList.push(targetMonth);
    }

    initCredentials()
      .then(() => {
        for (let yearMonth of this.yearMonthList) {
          let report = {
            monthly_statement_year: dateToyyyyMmStr(yearMonth),
            report_type: "04",
          };
          getPdfFileLambdaInvoke(report)
            .then((res) => {
              let resBody = JSON.parse(res.body);
              if (resBody.file_data) {
                this.reportMap[dateToyyyyMmStr(yearMonth)] =
                  dateToyyyyMmStr(yearMonth);
              }
            })
            .catch((error) => {
              goToErrorPage(error);
            });
        }
        getUserSessionLambdaInvoke()
          .then((res) => {
            for (let key in res) {
              if (
                this.userSessionData.hasOwnProperty.call(
                  this.userSessionData,
                  key
                )
              ) {
                this.userSessionData[key] = res[key];
              }
            }
          })
          .catch((error) => {
            goToErrorPage(error);
          });
      })
      .catch((error) => {
        goToErrorPage(error);
      });
  },
  methods: {
    yyyyMmJpDateFormat(date) {
      return date.getFullYear() + "年" + (date.getMonth() + 1) + "月";
    },
    dateToyyyyMmStr(date) {
      return date.getFullYear() + ("0" + (date.getMonth() + 1)).slice(-2);
    },
    showPdf(yearMonth) {
      const userSession = this.userSessionData["user_session"];
      const state = this.userSessionData["state"];
      const reportType = "04";
      const monthlyStatementYear = dateToyyyyMmStr(yearMonth);

      apiGetPdfFile({
        user_session: userSession,
        report_type: reportType,
        monthly_statement_year: monthlyStatementYear,
        state: state,
      })
        .then(() => {
          window.open(
            `${process.env.VUE_APP_GET_PDF_FILE}?user_session=${userSession}&report_type=${reportType}&monthly_statement_year=${monthlyStatementYear}&state=${state}`,
            "_blank"
          );
        })
        .catch((error) => {
          goToErrorPage(error);
        });
    },
    logout() {
      try {
        if (this.isDisabled) {
          return;
        }
        this.isDisabled = true;
        initCredentials()
          .then(() => {
            authLogout()
              .then(() => {
                removeUserSessionCookie();
                this.$router.push({ name: "tem024" });
              })
              .catch((error) => {
                goToErrorPage(error);
              });
          })
          .catch((error) => {
            goToErrorPage(error);
          })
          .finally(() => {
            this.isDisabled = false;
          });
      } catch (e) {
        goToErrorPage(e);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.heading-icon {
  text-align: left !important;
  justify-content: left !important;
  .heading {
    font-size: 16px !important;
  }
}
</style>
